import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const toggleGroundIcon = createIconDefinition(
  'toggleGroundIcon',
  `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10 13.7204L16.1333 8.94538L17.5 7.88704L10 2.05371L2.5 7.88704L3.85833 8.94538L10 13.7204ZM9.99167 15.837L3.85 11.062L2.5 12.112L10 17.9454L17.5 12.112L16.1417 11.0537L9.99167 15.837ZM14.7833 7.88704L10 4.16204L5.21667 7.88704L10 11.612L14.7833 7.88704Z" fill="#232426" fill-opacity="0.87"/>
</svg>`,
);
